import { StarIcon as StarIconOutline } from '@heroicons/react/24/outline';
import { StarIcon } from '@heroicons/react/24/solid';
import { usePatchSetRatingAccountRepresentativeMutation } from '@/slices/account-representative-api-slice.ts';
import type { AccountRepresentativeListModel } from '../../types/account-representative.type.ts';

const RepRating = ({ data }: { data: AccountRepresentativeListModel }) => {
  const [patchRating] = usePatchSetRatingAccountRepresentativeMutation();
  return (
    <div className='flex flex-row gap-0.5'>
      {[1, 2, 3, 4, 5].map(star =>
        star <= data.rating ? (
          <StarIcon
            key={star}
            onClick={event => {
              event.stopPropagation();
              patchRating({ key: data.key, rate: star });
            }}
            className='size-4 cursor-pointer text-orange-400 transition-all hover:translate-y-[-2px]'
          />
        ) : (
          <StarIconOutline
            key={star}
            onClick={event => {
              event.stopPropagation();
              patchRating({ key: data.key, rate: star });
            }}
            className='size-4 cursor-pointer transition-all hover:translate-y-[-2px]'
          />
        ),
      )}
    </div>
  );
};

export default RepRating;
